<template>
    <div class="common-table-wrapper">
            <el-table 
                :data="data" 
                v-loading="loading" 
                tooltip-effect="light" 
                size="small" 
                ref="tableRef" 
                :border="border"
                :show-header="showHeader" 
                header-row-class-name="stCommonTable" 
                :header-cell-class-name="cellClass"
                @selection-change="handleSelectionChange"
                @cell-click="handleCellClick"
                style="width: 100%" 
                :cell-style="cellStyleMothod" 
                :span-method="spanMethod" 
                :highlight-current-row="highlight"
                :show-summary="showSummary" 
                :summary-method="getSummaries" 
                :count-data="countData"
                height="500"
                :default-expand-all="defaultExpandAll"
                @current-change="singleSelectChange" 
                @sort-change="handleSortChange" 
                v-bind="$attrs"
            >
            <!-- 勾选框 -->
            <el-table-column :selectable="tableColumns[0].selectable" type="selection" width="60"
                :fixed="tableColumns[0].fixed" v-if="tableColumns && tableColumns[0].type === 'selection'">
            </el-table-column>
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <el-table-column 
                v-for="column in tableColumns" 
                :prop="column.key" 
                :label="column.title" 
                :type="column.type" 
                :min-width="column.index?55:(column.width || 170)" 
                :sortable="column.sortable" 
                :render-header="column.renderHeader"
                :show-overflow-tooltip="column.operate ? false : column.showTooltip === false ? false : true"
                v-if="column.type !== 'selection' && !column.hide" 
                :key="column.key"
                :fixed="column.fixed" 
                :align="column.align || 'left'"
                :class-name="column.className"
                >
                <template slot="header" slot-scope="scope">
                    <el-tooltip :content="column.content" v-if="column.tooltip" placement="bottom-start" effect="light">
                        <i class="el-icon-question"></i> </el-tooltip><span v-if="column.mustFill"
                        class="must-tips">*</span>{{ column.title }}
                </template>
                <!--eslint-enable-->
                <template slot-scope="{ row, $index }">
                    <!-- 各种类型的列如果有需要的可以继续添加 -->
                    <!-- 列的slot -->
                    <slot :name="column.slotName" v-if="column.slot" :row="row" :index="$index"></slot>

                    <column-render v-else-if="column.render" :row="row" :index="$index" :render="column.render"></column-render>

                    <span v-else-if="!column.operate && !column.input && column.key">
                        {{column.formatter ? column.formatter(row[column.key], $index, row) : row[column.key]}}
                    </span>

                    <span v-else-if="column.index">
                        {{$index+1}}
                    </span>

                    <span v-else-if="column.input && column.key">
                        <el-input v-model="row[column.key]" :type="column.type || 'number'" size="mini"
                            :maxlength="column.maxLength" clearable
                            :class="{ 'show-word-limit-input': column.showWordLimit }"
                            :show-word-limit="column.showWordLimit">
                            <template v-if="column.append" slot="append">{{ column.append }}</template>
                        </el-input>
                    </span>

                    <div v-else-if="column.operate">
                        <span v-for="(item, idx) in column.setBtns(row, $index)"
                            :key="idx">
                            <el-button style="margin: 0 2px;" :disabled="item.disabled" v-if="!item.hide" :style="item.style"
                                :type="item.type || 'text'" :size="item.size || 'medium'" @click="item.handler(row, $index)"
                                v-bind="$attrs">{{ item.label }}</el-button>
                        </span>
                    </div>
                    <div v-else-if="column.viewImg" style="padding:10px 0">
                        <img v-if="row[column.imgProps]"  :src="row[column.imgProps]" @click="column.handler(row[column.imgProps])" style="width: 50px;height: 50px;cursor: pointer; vertical-align: middle;" >
                        <span v-else>暂无</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        
        <div class="bootom-wrapper">
            <!-- 分页器 -->
            <div class="pager">
                <div  v-if="showPage"> 
                    <el-pagination 
                    :layout="pageConfig.layout || defaultLayout" 
                    :page-size="pageConfig.pageSize || defaultPageSizes[0]" 
                    :page-sizes="pageConfig.pageSizes || defaultPageSizes" 
                    :pager-count="5"
                    :current-page="pageConfig.currentPage"
                    @current-change="currentChange" 
                    @size-change="sizeChange" 
                    :background="true"
                    :prev-text="'上一页'"
                    :next-text="'下一页'"
                    :total="pageConfig.total">
                    </el-pagination>
                </div>
            </div>
    
            <div class="bottom-handle">
                <!-- <el-button type="primary" size="small">导出</el-button> -->
                <el-button v-for="(item, idx) in bottomHandleArr"
                    :key="idx" 
                    :disabled="item.disabled" 
                    v-if="!item.hide" 
                    :style="item.style"
                    :type="item.type || 'primary'" :size="item.size || 'medium'"
                    @click="item.handler()"
                    v-bind="$attrs">{{ item.label }}
                </el-button>
                <slot name="companyBalance" v-if="bottomSpareData"  ></slot>
            </div>
        </div>
    </div>
</template>
<script>
    // 自定义内容的组件 render函数
    const ColumnRender = {
        functional: true,
        props: {
            row: Object,
            render: Function,
            index: Number,
            column: {
                type: Object,
                default: null
            }
        },
        render: (h, data) => {
            const params = {
                row: data.props.row,
                index: data.props.index
            }
            if (data.props.column) params.column = data.props.column
            return data.props.render(h, params)
        }
    }
    export default {
        name: 'CommonTable',
        components: {
            ColumnRender
        },
        props: {
            data: {
                type: Array
            },
            countData: {
                type: Object,
            },
            bottomHandleArr: {
                type: Array,
            },
            highlight: {
                type: Boolean,
                default: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            border: {
                type: Boolean,
                default: false
            },
            showHeader: {
                type: Boolean,
                default: true
            },
           
            tableColumns: {
                type: Array
            },
            spanMethod: {
                type: Function
            },
            summaryMethod: {
                type: Function
            },
            showPage: {
                type: Boolean,
                default: false
            },
            showSummary: {
                type: Boolean,
                default: false
            },
            cellStyleMothod: {
                type: Function
            },
            defaultExpandAll: { 
                type: Boolean, 
                default: false 
            },
            bottomSpareData:{
                type: Boolean, 
                default: false 
            },
            // 分页配置
            pageConfig: {
                type: Object,
                default: function() {
                    return {
                        layout: "total, sizes, prev, pager, next, jumper", // 组件布局
                        total: 0, // 总条目数
                        pageSize: 50, // 每页展示的数量
                        pageSizes: [3, 100, 200, 300,5000], // 每页显示个数选择器的选项设置
                        currentPage: 1, // 当前页数，支持 .sync 修饰符
                    }
                }
            },
            selectType: { 
                type: Boolean, 
                default: false 
            },
        },
        data() {
            return {
                defaultLayout: "total, sizes, prev, pager, next, jumper",
                defaultPageSizes: [50, 100, 200, 300,5000],
                defaultCurrentPage: 1
            }
        },
        computed: {

        },
       
        methods: {
            toggleRowExpansion(row, e) {
                this.$refs.tableRef.toggleRowExpansion(row, e)
            },
            handleSortChange(val) {
                this.$emit('handleSortChange', val)
            },
            singleSelectChange(val) {
                this.$emit('singleSelectChange', val)
            },
            currentChange(val) {
                this.$emit('currentChange', val)
            },
            sizeChange(val) {
                this.$emit('sizeChange', val)
            },
            handleSelectionChange(val) {
                this.$emit('selectionChange', val)
            },
            handleCellClick(row, column){
                this.$emit('cellClick', row, column)
            },
            getSummaries(params) {
                let _arr = this.summaryMethod ? this.summaryMethod(params) : this.defaultGetSummaries(params)
                return _arr
            },
            defaultGetSummaries(params) {
                this.$nextTick(() => {
                    this.$refs.tableRef.doLayout();
                });
                if (!this.countData) return ['合计']

                let sums = [];
                var selectedColm = params.columns;
                let newArray = []
                selectedColm.forEach(a => {
                    if (this.countData[a.property]) {
                        newArray.push(this.countData[a.property])
                    } else {
                        newArray.push('')
                    }
                });
                sums = newArray;
                sums[0] = "合计";
                return sums;
            },
            clearSelection() {
                this.$refs.tableRef.clearSelection()
            },
            toggleRowSelection(row, selected = true) {
                this.$nextTick(() => {
                    this.$refs.tableRef.toggleRowSelection(row, selected)
                })
            },
            toggleAllSelection() {
                this.$nextTick(() => {
                    this.$refs.tableRef.toggleAllSelection()
                })
            },
            cellClass(row){ 
                if (row.columnIndex === 0 && this.selectType) {           
                    return 'disabledCheck'     
                } 
            },
        }
    }
</script>

<style scoped>
    .common-table-wrapper{
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 8px;
        width: calc(100% - 16px);
        bottom: 8px;
    }
    .bootom-wrapper {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-right: 20px;
    }
    .el-table  /deep/td.optionWaybillNo{
        color: #FF5B3E;
        cursor: pointer;
    }
    /* .el-table /deep/.cell{
        font-size: 14px ;
        height: 36px;
        line-height: 36px;
    }
    .deiverMaterialBox .el-table th /deep/.cell{
        font-size: 14px ;
        height: 80px;
        line-height: 80px;
    } */
</style>